module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-medium-dcc1613d.svg";